import React from 'react';

import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function TrussGroupsContainerMenu() {
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="trussGroup" />
    </SceneMenuContent>
  );
}
